function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-33824f2a\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppHeadingTextBlock.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppHeadingTextBlock.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-33824f2a\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppHeadingTextBlock.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33824f2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppHeadingTextBlock/AppHeadingTextBlock.vue
// module id = ab896b80573f4cd9b293
// module chunks = 89